import React, { useEffect, useState } from 'react'
import innerStyles from "./InnerStyles.module.css"
import axios from 'axios'
const Offers = () => {
   const[data,setData]=useState([])
  useEffect(()=>{
    axios.get(`https://backendsurgylife-1.onrender.com/offer`)
    .then((res)=>{
      setData(res.data)
    })
    .catch((err)=>{
      alert("Error Fetching offers")
    })
  })
  return (
      <main>
       
               <section className={innerStyles.breadgum}>
                   <div className='container'>
                       <div className='row'>
                           <div className='col-md-12'>
                               <h1>Offers</h1>
                           </div>
                       </div>
                   </div>
               </section>


                   <section className={`py-5 ${innerStyles.aboutus}`}>
                   <div className='container'>
                       <div className='row'>
                        {
                          data.map((offerdata)=>{
                            return(
                              <div className='col-md-12  ' key={offerdata._id}>
                                <div className='mb-4 border-bottom'>
                              <p>  
                              {offerdata.odesc}
                               </p>
                                </div>
                              </div>
                            )
                          })
                        }
                       </div>
                   </div>
               </section>

               </main>
  )
}

export default Offers
